// eslint-disable-next-line no-restricted-imports
import { atom as recoilAtom, AtomOptions, RecoilState } from "recoil";
import { RecoilKeys } from "./RecoilKeys";

type OurAtomOptions<T> = AtomOptions<T> & {
  readonly key: RecoilKeys;
};

// eslint-disable-next-line functional/prefer-tacit, @typescript-eslint/prefer-readonly-parameter-types
export function atom<T>(options: OurAtomOptions<T>): RecoilState<T> {
  return recoilAtom(options);
}
